export default "__VITE_ASSET__Bil$MdeT__"